import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from '../../context/store';
import { useHistory } from 'react-router-dom';

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import DashboardSelector from "../../components/DashboardSelector";

import MetricRadarHero from "./components/MetricRadarHero";
import OutlierSummaryDrawer from "./components/OutlierSummaryDrawer";
import WhiteMetricDrawer from "./components/WhiteMetricDrawer";

import {CARD_STYLE} from "../../constants/styles";
import {CHART_CONTAINER_STYLE} from "../../constants/styles";


import { functions } from "../../constants/common-functions";

export default function Outliers() {

    const globalState = useContext(store);
    const { dispatch } = globalState;
    const history = useHistory();

    const refFacility = useRef(null);
	
	
	const [activeMetric, setActiveMetric]= useState(null);
	
	
	useEffect(() => {
		 functions.redirectDemoUser(history);
	  }, []);

    /* =========================
       STATE
    ========================== */

   

    /* =========================
       DEMO DATA
    ========================== */

    useEffect(() => {

       

    }, []);

    /* =========================
       STYLES
    ========================== */

    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        left: "0px",
        top: "0px"
    };

    const mainContainer = {
        display: "flex",
        position: "fixed",
        top: "60px",
        left: "60px",
        bottom: "0px",
        right: "0px",
        overflow: "hidden"
    };

    const canvas = {
        position: "absolute",
        top: 30,
        left: 280,
        bottom: 30,
        right: "300px",
        //background: "linear-gradient(180deg, #f2f3f5 0%, #e6e8eb 100%)",
        padding: "20px"
    };

    const drawer = {
        position: "fixed",
        top: "90px",
        right: 0,
        bottom: 30,
        width: "300px",
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px",
        background: "linear-gradient(180deg, #0b0b0d 0%, #15161a 100%)",
        boxShadow: "-12px 0 30px rgba(0,0,0,0.45)",
        color: "#fff",
		borderTopLeftRadius:'17px',
		borderBottomLeftRadius:'17px',
		zIndex:4
    };



    const sectionDivider = {
        height: "1px",
        background: "rgba(255,255,255,0.08)",
        margin: "12px 0"
    };
	
	// KPI TILE STYLES (Space Dashboard flavour)

	const kpiTile = {
	    background: "linear-gradient(180deg, #0d1116 0%, #151b22 100%)",
	    borderRadius: "16px",
	    padding: "18px 18px",
	    boxShadow: "0 14px 32px rgba(0,0,0,0.28)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "6px"
	};

	const kpiLabelDark = {
	    fontSize: "11px",
	    letterSpacing: "0.8px",
	    textTransform: "uppercase",
	    color: "rgba(255,255,255,0.55)"
	};

	const kpiValueAccent = (color) => ({
	    fontSize: "30px",
	    fontWeight: 700,
	    color: color,
	    lineHeight: "1.1"
	});

	const kpiSubDark = {
	    fontSize: "13px",
	    color: "rgba(255,255,255,0.6)"
	};

	// Calm, planning-style accents
	const SPACE_ACCENT = "#4dd0e1";
	const PEOPLE_ACCENT = "#7aa2ff";
	const RATIO_ACCENT  = "#b18cff";
	
	const metricsRail = {
	    position: "absolute",
	    top: 30,
	    left: 30,
	    width: "200px",
	    padding: "22px 20px",
	    background: "rgba(255,255,255,0.75)",
	    borderRadius: "14px",
	    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "22px",          // 👈 controls vertical rhythm
	    backdropFilter: "blur(6px)",
		paddingBottom:'60px'
	};

	const metricBlock = {
	    display: "flex",
	    flexDirection: "column",
		paddingTop:'40px'
	};

	const metricLabel = {
	    fontSize: "11px",
	    letterSpacing: "0.8px",
	    textTransform: "uppercase",
	    color: "#666",
	    marginBottom: "6px"
	};

	const metricValue = {
	    fontSize: "32px",
	    fontWeight: 600,
	    color: "#111"
	};

	const metricSub = {
	    fontSize: "14px",
	    color: "#444",
	    marginTop: "4px"
	};
	
	
	const railDivider = {
	    height: "1px",
	    background: "rgba(0,0,0,0.08)",
	    margin: "6px 0"
	};
	
	
	const railControls = {
	    display: "flex",
	    flexDirection: "column",
	    gap: "10px"
	};

	const railSelect = {
	    height: "32px",
	    borderRadius: "8px",
	    border: "1px solid #ddd",
	    fontSize: "12px",
	    padding: "0 10px",
	    background: "#fff"
	};
	
	
	const railToggle = {
	    display: "flex",
	    background: "#eee",
	    borderRadius: "16px",
	    padding: "2px",
	    marginTop: "6px"
	};

	const railToggleOption = (active) => ({
	    flex: 1,
	    textAlign: "center",
	    padding: "6px 0",
	    fontSize: "12px",
	    borderRadius: "14px",
	    cursor: "pointer",
	    background: active ? "#111" : "transparent",
	    color: active ? "#fff" : "#555",
	    transition: "all 0.2s ease"
	});
	
	const trend = (direction, color) => ({
	    fontSize: "12px",
	    color: color,
	    display: "flex",
	    alignItems: "center",
	    gap: "4px"
	});
	
	
	
	const detailDrawer = (open) => ({
	    position: "fixed",
	    top: "90px",
	    left: open ? "80px" : "100%",
	    bottom: "30px",
	    width: "calc(100% - 430px)",
	    background: "#ffffff",
	    boxShadow: "-24px 0 48px rgba(0,0,0,0.22)",
	    borderTopLeftRadius: "22px",
	    borderBottomLeftRadius: "22px",
	    transition: "left 0.6s cubic-bezier(0.22, 0.61, 0.36, 1)",
	    zIndex: 3,
	    display: "flex",
	    overflow: "hidden",
		paddingRight:'20px'
	});
	
	const overlayStyle = {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    width: "100%",
	    height: "100%",

	    background: "rgba(255,255,255,0.85)",

	    pointerEvents: "none",

	    opacity: 0,

	    animation: "fadeOverlay 4s ease forwards"
	  };

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>
            <Header />
            <LeftMenu />
			<div style={overlayStyle}/>
            <DashboardSelector
                title="Outliers & Issues"
                childDashboards={[]}
            />

            <div style={mainContainer}>

			
			<div style={metricsRail}>
			{/* KPI TILES */}
			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Cost</div>
			    <div style={kpiValueAccent("#ff6b6b")}>14</div>
			    <div style={kpiSubDark}>assets outside norm</div>
			    <div style={trend("up", "#ff6b6b")}>▲ +3 vs last period</div>
			</div>

			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Cost / m²</div>
			    <div style={kpiValueAccent(RATIO_ACCENT)}>11%</div>
			    <div style={kpiSubDark}>of portfolio</div>
			    <div style={trend("down", "#6ee7b7")}>▼ improving</div>
			</div>

			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Area</div>
			    <div style={kpiValueAccent(SPACE_ACCENT)}>9</div>
			    <div style={kpiSubDark}>significant deviations</div>
			    <div style={trend("flat", "#aaa")}>— no change</div>
			</div>

			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Headcount</div>
			    <div style={kpiValueAccent(PEOPLE_ACCENT)}>6</div>
			    <div style={kpiSubDark}>assets affected</div>
			    <div style={trend("up", "#ff6b6b")}>▲ +1</div>
			</div>

			
				
				
				<div style={railDivider} />

				    {/* CONTROLS */}
				    <div style={railControls}>
				        

				        <div style={railToggle}>
				            <div style={railToggleOption(true)}>Buildings</div>
				            <div style={railToggleOption(false)}>Assets</div>
				        </div>
				    </div>

			</div>
			
                {/* MAIN CANVAS */}
                <div style={{...canvas}}>
					<MetricRadarHero
					onMetricSelect={(metric) => setActiveMetric(metric)}
					/>
                </div>
				
				
				
				

				{/* BLACK DRAWER */}
				<div style={drawer}>

				   <OutlierSummaryDrawer/>

				   

				</div>
				<div style={detailDrawer(!!activeMetric)}>
							    {activeMetric && (
							        <WhiteMetricDrawer
									 metric={activeMetric} 
									 onClose={() => setActiveMetric(null)}
									/>
							    )}
							</div>
            </div>
			
        </div>
    );
}